import {
  DefaultEditorOptions,
  RichTextInput,
  RichTextInputToolbar,
  LevelSelect,
  FormatButtons,
  AlignmentButtons,
  ListButtons,
  LinkButtons,
  QuoteButtons,
  ClearButtons,
  ColorButtons,
  RichTextInputProps,
  useTiptapEditor,
} from 'ra-input-rich-text';
import Image from '@tiptap/extension-image';
import ImageIcon from '@mui/icons-material/Image';
import { ToggleButton } from '@mui/material';
import React, { useRef } from 'react';
import AiToolbar from './AiToolbar';
import Permission from '../Permission';
import { PERMISSIONS } from '../../constants';

// Botão de imagem customizado
const ImageButton = ({ size }: { size?: 'small' | 'medium' | 'large' }) => {
  const editor = useTiptapEditor();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file || !editor) return;

    const reader = new FileReader();
    reader.onload = () => {
      const base64 = reader.result as string;
      editor.commands.setImage({ src: base64 });
    };
    reader.readAsDataURL(file);

    event.target.value = '';
  };

  return (
    <>
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        style={{ display: 'none' }}
        ref={inputRef}
      />
      <ToggleButton
        value="image"
        size={size}
        onClick={handleClick}
        disabled={!editor?.isEditable}
        title="Inserir imagem"
      >
        <ImageIcon fontSize="inherit" />
      </ToggleButton>
    </>
  );
};

// Custom editor options with Image configured as block (not inline) and allowBase64
const CustomEditorOptions = {
  ...DefaultEditorOptions,
  extensions: [
    ...DefaultEditorOptions.extensions.filter(
      (ext: any) => ext.name !== 'image'
    ),
    Image.configure({
      inline: false, // Block mode - allows insertion in empty editor
      allowBase64: true, // Allow base64 data URLs
    }),
  ],
};

export const RichTextInputCustom: React.FC<RichTextInputProps & { fieldType?: string }> = ({ size, fieldType, ...props }: any) => (
  <RichTextInput
    editorOptions={CustomEditorOptions}
    toolbar={
      <RichTextInputToolbar>
        <LevelSelect size={size} />
        <FormatButtons size={size} />
        <ColorButtons size={size} />
        <AlignmentButtons size={size} />
        <ListButtons size={size} />
        <LinkButtons size={size} />
        <QuoteButtons size={size} />
        <ClearButtons size={size} />
        <ImageButton size={size} />
        <Permission permission={PERMISSIONS.TEXT_EDITOR_AI}>
          <AiToolbar size={size} fieldType={fieldType} />
        </Permission>
      </RichTextInputToolbar>
    }
    {...props}
  />
);

export const RichTextInputOptions = DefaultEditorOptions;
